module.exports = __webpack_public_path__ + "img/water.c749c232.svg";